import { render } from "./DialogueMenuSkills.vue?vue&type=template&id=51b99651&scoped=true"
import script from "./DialogueMenuSkills.vue?vue&type=script&lang=js"
export * from "./DialogueMenuSkills.vue?vue&type=script&lang=js"

import "./DialogueMenuSkills.vue?vue&type=style&index=0&id=51b99651&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b99651"]])

export default __exports__